module.exports = __webpack_public_path__ + "img/var_02_gas.460decae.png";